var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconAirplaneLanding = function SvgIconAirplaneLanding(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M1.25 4.79v4.931a3.99 3.99 0 0 0 2.925 3.852h-.001l.27-.964-.267.964 16.553 4.64A1 1 0 0 0 22 17.25v-3.347h-1l1 .002a3.99 3.99 0 0 0-2.926-3.853l-4.16-1.155-2.796-4.893a1 1 0 0 0-.552-.453l-1.265-.422h-.004A1.75 1.75 0 0 0 8 4.79V6.89l-1.31-.41-1.308-2.45a1 1 0 0 0-.566-.479L3.551 3.13h-.004A1.75 1.75 0 0 0 1.25 4.79m2 4.932V5.137l.555.186 1.313 2.46a1 1 0 0 0 .584.484l3 .937A1 1 0 0 0 10 8.25V5.137l.571.19 2.81 4.92a1 1 0 0 0 .601.466l4.558 1.266A1.99 1.99 0 0 1 20 13.901v2.03L4.714 11.646H4.71a1.99 1.99 0 0 1-1.46-1.922l-1-.002z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 19.25a1 1 0 1 0 0 2h13.5a1 1 0 1 0 0-2z"
  }))));
};
export default SvgIconAirplaneLanding;